import React, { Fragment } from 'react'
import GroupHeader from './components/GroupHeader'
import Platforms from './components/Platforms'
import PlatformEntry from './components/PlatformEntry'
import PlatformSectionTitle from './components/PlatformSectionTitle'
import PlatformNavLink from './components/PlatformNavLink'
import NavGrid from 'components/NavGrid'
import Section from './components/Section'
import SectionByline from './components/SectionByline'
import SectionHeadline from './components/SectionHeadline'
import SectionIntro from './components/SectionIntro'
import { Container, withTheme, DiagonalDividerHorizontal } from 'stylist'
import platforms from 'config/platforms'
import rawPlatformEntries from 'config/platformEntries'
import { prop } from 'utils/fp'

const platformEntries = rawPlatformEntries.reduce(
  (memo, platform) => ({
    ...memo,
    [platform.group]: [...(memo[platform.group] || []), platform]
  }),
  {}
)

const RouteHomeIndex = ({ match: { path }, theme }) => (
  <Fragment>
    <Section background="ink">
      <Container>
        <NavGrid>
          <PlatformSectionTitle>My FocusVision</PlatformSectionTitle>
          {platforms
            .filter(prop('displayOnHomepage'))
            .map(platform => (
              <PlatformNavLink key={platform.id} platform={platform} />
            ))}
        </NavGrid>
      </Container>
    </Section>
    <Section css="padding-top: 0" background="white">
      <DiagonalDividerHorizontal />
      <Container>
        <SectionIntro>
          <SectionHeadline>
            Every challenge has a solution. It depends on your question.
          </SectionHeadline>
          <SectionByline>
            No matter your role, research can help your business.
          </SectionByline>
        </SectionIntro>
        <Platforms>
          <GroupHeader>Surveys & Reporting</GroupHeader>
          {platformEntries['surveys-and-reporting'].map(entry => (
            <PlatformEntry key={entry.title} entry={entry} />
          ))}
          <GroupHeader>Digital Qual & Live Video</GroupHeader>
          {platformEntries['digital-qual'].map(entry => (
            <PlatformEntry key={entry.title} entry={entry} />
          ))}
          <GroupHeader>Video Management</GroupHeader>
          {platformEntries['video-management'].map(entry => (
            <PlatformEntry key={entry.title} entry={entry} />
          ))}
        </Platforms>
      </Container>
    </Section>
  </Fragment>
)

export default withTheme(RouteHomeIndex)



// WEBPACK FOOTER //
// ./src/routes/home/index.js